import React, { useState, useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { Contact } from "./components/contact";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";
import TagManager from 'react-gtm-module';
import Contato from './pages/contato';
import About from './pages/sobre';
import Produtos from './pages/produtos';
import Localizacao from './pages/localiza';
import PaginaNaoEncontrada from "./pages/notfound";
import Home from "./pages/home";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  useEffect(() => {
    const tagManagerArgs = {
        gtmId: 'GTM-TX3VDHC'
    };
    TagManager.initialize(tagManagerArgs);
  }, []);
  return (
    <div>
        <div>
        <BrowserRouter>
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/contato" element={<Contato />} />
            <Route path="/sobre" element={<About />} />
            <Route path="/produtos" element={<Produtos />} />
            <Route path="/localizacao" element={<Localizacao />} />
            <Route path="*" element={<PaginaNaoEncontrada />} />
        </Routes>
        </BrowserRouter>
        </div>
    </div>
  );
};  

export default App;
